import { Box, Grid, Tab, Tabs } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { TabContext, TabPanel } from '@material-ui/lab';
import { useState } from 'react';

import { ApplicationFormContainer } from '../ApplicationsForm/applications-form.styles';
import ChangePassword from './components/change-password';
import ChangePhone from './components/change-phone';
// import ChangeUserInfo from './components/change-user-info';

const useStyles = makeStyles((theme) =>
  createStyles({
    tabTop: {
      marginTop: theme.spacing(3)
    }
  })
);

const AccountLanding = () => {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState('password');

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <ApplicationFormContainer>
      <TabContext value={selectedTab}>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h4">Account Settings</Typography>
          </Grid>
          <Grid item xs={12} className={classes.tabTop}>
            <Box borderBottom={1} borderColor="grey.400">
              <Tabs value={selectedTab} onChange={handleTabChange} indicatorColor="secondary">
                <Tab value="password" label="Password" />
                <Tab value="phone" label="Phone" />
              </Tabs>
            </Box>
          </Grid>
        </Grid>
        <Grid container justifyContent="center" spacing={2}>
          <Grid item xs={12} sm={8}>
            <Box mt={2}>
              <TabPanel value="password">{selectedTab === 'password' && <ChangePassword tab={selectedTab} />}</TabPanel>
              <TabPanel value="phone">{selectedTab === 'phone' && <ChangePhone tab={selectedTab} />}</TabPanel>
            </Box>
          </Grid>
        </Grid>
      </TabContext>
    </ApplicationFormContainer>
  );
};

export default AccountLanding;
